import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=50275fa2"
import script from "./PersonDetails.vue?vue&type=script&lang=js"
export * from "./PersonDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports